import { Breakpoint, styled } from "@mui/material";

export const MainContentWrapper = styled("main")<{
  fullWidth?: boolean;
  maxWidth?: Breakpoint;
}>(({ theme, fullWidth = false, maxWidth = fullWidth ? undefined : "lg" }) => ({
  flexGrow: theme.spacing(1),
  paddingBlockStart: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(4),
  color: theme.palette.text.secondary,
  "& .MuiTextField-root": {
    color: "inherit",
  },
  maxWidth: maxWidth && theme.breakpoints.values[maxWidth],
}));
